const PREFIX_STR = '[Table]';

export const log = {
  error: (...rest: any) => {
    console.error(PREFIX_STR, ...rest);
  },
  info: (...rest: any) => {
    console.log(PREFIX_STR, ...rest);
  },
};
